<template>
  <div ref="svgElementContainer"></div>
</template>
<script>
import { OrgChart } from "d3-org-chart";
import * as d3 from "d3";
export default {
  name: "OrgChart",
  props: ["data"],
  data() {
    return {
      chartReference: null
    };
  },
  methods: {
    renderChart(data) {
      const self = this;
      if (!this.chartReference) {
        this.chartReference = new OrgChart();
      }
      this.chartReference
        .container(this.$refs.svgElementContainer) // node or css selector
        .data(data)
        .nodeWidth(d => {
          return d.data.isOrganization ? 250 : 275;
        })
        .onNodeClick(d => this.$emit("nodeClick", d))
        .nodeHeight(d => {
          return d.data.isOrganization ? 150 : 75;
        })

        .compactMarginBetween(d => 50)
        .siblingsMargin(d => 100)
        .initialZoom(1)
        .linkUpdate(function(d, i, arr) {
          d3.select(this)
            .attr("stroke", d =>
              d.data._upToTheRootHighlighted ? "#14760D" : "#2CAAE5"
            )
            .attr("stroke-width", d =>
              d.data._upToTheRootHighlighted ? 15 : 1
            );

          if (d.data._upToTheRootHighlighted) {
            d3.select(this).raise();
          }
          self.$emit("render");
        })
        .buttonContent(d => {
          return `<div style="color:#716E7B;border-radius:5px;padding:4px;font-size:10px;margin:auto auto;background-color:white;border: 1px solid #E4E2E9"> <span style="font-size:9px">${
            d.node.children
              ? `<i class="fas fa-angle-up"></i>`
              : `<i class="fas fa-angle-down"></i>`
          }</span> ${d.node.data._totalSubordinates}  </div>`;
        })
        .nodeContent(d => {
          return d.data.isOrganization
            ? `
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items:center;background-color:${d.data.backgroundColor};width:${d.width}px;height:${d.height}px">
                  <div style="flex-grow:2">
                  </div>
                        <img width=${d.data.nodeImage.width} height=${d.data.nodeImage.height} src="${d.data.nodeImage.url}"/>
                ${d.data.template}
              </div>
              `
            : `<div style="display: flex; flex-direction: row; justify-content:flex-start;
                ;align-items: center;padding-left: 10px;background-color:${
                  d.data.backgroundColor
                };width:${d.width + 35}px;height:${d.height - 5}px">
                <img class="picture-preview" width=${
                  d.data.nodeImage.width
                } height=${d.data.nodeImage.height} src="${
                d.data.nodeImage.url
              }"/>
                ${d.data.template}
              </div>`;
        })

        .render();
    }
  },
  watch: {
    data(value) {
      this.renderChart(value);
      this.chartReference.expandAll();
    }
  }
};
</script>
